import CryptoJS from 'crypto-js';
export class NadlCrypto {
    // Use this for lazy initialization
    init(cipher, iv) {
        this.cipher = CryptoJS.enc.Utf8.parse(cipher);
        const ivParsed = CryptoJS.enc.Utf8.parse(iv);
        this.cfg = {
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            iv: ivParsed
        };
    }
    decrypt(encryptedString) {
        return CryptoJS.AES.decrypt(encryptedString, this.cipher, this.cfg).toString(CryptoJS.enc.Utf8);
    }
    encrypt(normalString) {
        return CryptoJS.AES.encrypt(normalString, this.cipher, this.cfg).toString();
    }
}
//# sourceMappingURL=cryto.service.js.map